<template lang="html">
  <div>
    <Dashboard/>
  </div>
</template>

<script>
import Dashboard from './Dashboard.vue'

export default {
  components: {
    Dashboard
  }
}
</script>